import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default function changeMeetingStatus(leadId, salesAgentId) {
	var leadRef;

	var checkRef;

	firebaseRef
		.ref('/kavtek_leads/' + PROJECT_CODE.projectCode + '/' + leadId)
		.once('value', (snapshot) => {
			checkRef = snapshot.val();
		});

	if (checkRef) {
		leadRef = firebaseRef.ref(
			'/kavtek_leads/' + PROJECT_CODE.projectCode + '/' + leadId
		);
	} else {
		leadRef = firebaseRef.ref(
			'/kavtek_purchasers/' +
				PROJECT_CODE.projectCode +
				'/' +
				salesAgentId +
				'/' +
				leadId
		);
	}

	leadRef.update({
		sentEmail: true,
	});
}
